export default __webpack_public_path__ + "static/media/results-example-1.8ec1f061.png";